import { gql, QueryHookOptions, useQuery } from "@apollo/client";
import { getFetchPolicyOptions } from "api/utils";
import { useGetContractIdData } from "providers/ContractIdProvider";
import { useDateRangeState } from "providers/DateRangeProvider";
import { useKeycloak } from "providers/KeycloakProvider";
import { toLongISOString } from "utils/date";
import { TRANSACTION_FIELDS } from "./fragments";
import { AllPortfoliosTransactionsQuery } from "./types";

const TRANSACTIONS_QUERY = gql`
  ${TRANSACTION_FIELDS}
  query GetAllPortfoliosTransactions(
    $startDate: String
    $endDate: String
    $contactId: Long
  ) {
    contact(id: $contactId) {
      id
      transactions(startDate: $startDate, endDate: $endDate, status: "OK") {
        ...TransactionsFields
      }
    }
  }
`;

export const useGetAllPortfoliosTransactions = (options?: QueryHookOptions) => {
  const { linkedContact } = useKeycloak();
  const { selectedContactId } = useGetContractIdData();
  const { startDate, endDate, fetchPolicyString } = useDateRangeState();

  const { loading, error, data } = useQuery<AllPortfoliosTransactionsQuery>(
    TRANSACTIONS_QUERY,
    {
      variables: {
        startDate: toLongISOString(startDate),
        endDate: toLongISOString(endDate),
        contactId: selectedContactId || linkedContact,
      },
      ...getFetchPolicyOptions(
        `useGetPortfolioTransactions.${
          selectedContactId || linkedContact
        }.${fetchPolicyString}`
      ),
      ...options,
    }
  );

  return {
    loading,
    error,
    data: data?.contact.transactions,
  };
};
